import {Route} from '../../routes/navigation';
import {RouteComponentProps} from 'react-router';
import {List} from '../Navigation/List';
import * as React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {tagsSelector} from '../../selectors/navigation';
import {experimentsSelector} from '../../selectors/experiments';
import {WithTranslation, withTranslation} from 'react-i18next';
import {getLabelByPath} from '../../utils';
import {findSearchTerms} from '../../utils/search';
import NavigationLink from '../partials/NavigationLink';
import s from './tags.scss';
import {Experiment} from '../../reducers/experiments';

export interface TagsProps extends RouteComponentProps<{}>, WithTranslation {
  tags: Route[];
  experiments: Experiment[];
}

class TagsCmp extends React.Component<TagsProps> {
  render () {
    const {tags, history, t, experiments} = this.props;
    const tagLabel = getLabelByPath(history.location.pathname, experiments);
    const searchTerms = findSearchTerms(history);
    const tag = tags.find(thetag => (thetag.labelForHeader || thetag.label) === tagLabel);

    if (!tag || searchTerms) {
      return null;
    }
    const visibleTags = tags.filter(filtered => filtered !== tag);

    return (
      <div className={s.tags} data-hooks="tags">
        <span className={s.label}>{t('wix.general.page.filtered.by')}:</span><NavigationLink HtmlTag="span" className={s.active} data-hooks="activeTag" link={tag}/>
        <List
          className={s.dropdown}
          itemClassName={s.tag}
          itemHooks="tag"
          history={history}
          items={visibleTags}
          behaviour="dropdown"
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tags: tagsSelector(state),
    experiments: experimentsSelector(state),
  };
}

export const Tags: any = withRouter(withTranslation()(connect(mapStateToProps, null)(TagsCmp)) as React.ComponentType<any>);
